import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick"];
import { Box, Text } from '@wix/design-system';
import React from 'react';
import { Groups, LockLocked, WixForum } from '@wix/wix-ui-icons-common/lazy';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './AnonymousResultsHeader.scss';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { BngResultsTitle } from './BngResultsTitle';
import { BngResultsDesktopHeader } from './BngResultsDesktopHeader';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { AnonymousVoucherBanner } from '../../VoucherBanner';
const TrustBuilderItem = _ref => {
  let icon = _ref.icon,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, icon, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, text));
};
export const BngResultsHeader = _ref2 => {
  let onBackClick = _ref2.onBackClick,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      width: "100%"
    }, /*#__PURE__*/React.createElement(AnonymousVoucherBanner, null), /*#__PURE__*/React.createElement(Box, {
      paddingTop: "SP3"
    }, /*#__PURE__*/React.createElement(HeaderWrapper, props, /*#__PURE__*/React.createElement(BngResultsTitle, null))));
  }
  const trustBuilders = [{
    icon: /*#__PURE__*/React.createElement(Groups, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.storefront_results.optimized.trust_builder.millions'
  }, {
    icon: /*#__PURE__*/React.createElement(LockLocked, {
      size: "18px"
    }),
    translationKey: 'domain_search_gate.storefront_results.trust_builder.ssl'
  }, {
    icon: /*#__PURE__*/React.createElement(WixForum, {
      size: "18px"
    }),
    translationKey: 'domains_search_gate.storefront_results.optimized.trust_builder.support'
  }];
  return /*#__PURE__*/React.createElement(BngResultsDesktopHeader, _extends({
    onBackClick: onBackClick
  }, props), /*#__PURE__*/React.createElement(Box, {
    gap: "SP6",
    align: "center",
    verticalAlign: "middle",
    className: s.whyWixBenefits
  }, trustBuilders.map(_ref3 => {
    let icon = _ref3.icon,
      translationKey = _ref3.translationKey;
    return /*#__PURE__*/React.createElement(TrustBuilderItem, {
      key: translationKey,
      icon: icon,
      text: t(translationKey)
    });
  })));
};
//# sourceMappingURL=BngResultsHeader.js.map